import React from 'react'
import { AiErrorIcon } from 'app/components/icons'
import { FormattedMessage } from 'react-intl'
import { Button } from '@material-ui/core'

const GenerateError = (props) => {
  const { onRetry } = props
  return (
    <div className="text-center px-64 space-y-5">
      <AiErrorIcon />
      <div className="text-blue-950 font-bold text-18">
        <FormattedMessage id="ai.dialog.error.title" />
      </div>
      <div className="text-blue-950 text-14">
        <FormattedMessage id="ai.dialog.error.detail" />
      </div>
      <div className="pt-10 pb-5">
        <Button
          onClick={onRetry}
          variant="contained"
          style={{
            width: '150px',
            background: '#183560',
            color: '#ffffff',
            textTransform: 'none !important',
          }}
        >
          <FormattedMessage id="action.tryAgain" />
        </Button>
      </div>
    </div>
  )
}

export default GenerateError
